export default __webpack_public_path__ + "static/media/kitchen3-before3-2048w.14ae825f.png";